/**
 * Lib identity token + scoped warn/panic for @norkron/web-sync-queue.
 *
 * Extracted into a leaf module so internal files (`backoff.ts`, `uuid-v7.ts`,
 * `validate-input.ts`, etc.) can import the scoped emitters without creating
 * a circular dependency through `./index.ts`.
 */
import { createScopedErrors } from '@norkron/web-errors'

export const SYNC_QUEUE_LIB = '@norkron/web-sync-queue'
export const SYNC_QUEUE_LIB_TOKEN = Symbol.for('norkron.lib.web-sync-queue')
export const { warn, panic, reportInvalidInput } = createScopedErrors(SYNC_QUEUE_LIB, SYNC_QUEUE_LIB_TOKEN)
